"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwallexConfigOutSerializer = void 0;
exports.AirwallexConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=airwallexConfigOut.js.map